import { render, staticRenderFns } from "./adContract.vue?vue&type=template&id=94c35f72&scoped=true&"
import script from "./adContract.vue?vue&type=script&lang=js&"
export * from "./adContract.vue?vue&type=script&lang=js&"
import style0 from "./adContract.vue?vue&type=style&index=0&id=94c35f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c35f72",
  null
  
)

export default component.exports